<script setup lang="ts">
import "./assets/main.css";
import { RouterLink, RouterView } from "vue-router";
import HeaderText from "./components/HeaderText.vue";
import PageFooters from "./components/PageFooters.vue";
</script>

<template>
  <header>
    <div class="wrapper">
      <a class="logo" href="/">
        <img
          alt="PICNIC logo"
          class="logo"
          height="125"
          src="@/assets/logo_picnic_v1.png"
          width="200"
        />
      </a>

      <HeaderText msg="PICNIC (Proteins Involved in CoNdensates In Cells)" />

      <nav>
        <RouterLink to="/">Home</RouterLink>
        <RouterLink to="/calculate">Calculate score</RouterLink>
        <RouterLink to="/browse">Browse data</RouterLink>
        <RouterLink to="/about-us">About</RouterLink>
        <RouterLink to="/help">Help</RouterLink>
      </nav>
    </div>
  </header>

  <Suspense>
    <RouterView />
  </Suspense>

  <PageFooters />
</template>

<style scoped lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  text-align: center;
  margin: 2rem 2rem;
  font-size: 1.1rem;
  padding: 1rem 0;
}

nav a {
  color: var(--color-text);
}

nav a:hover {
  color: hsla(326, 100%, 46%, 1);
}

nav a.router-link-exact-active {
  color: hsla(326, 100%, 46%, 1);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-top: 10px;
    padding-right: 10px;
  }

  .logo:hover {
    color: unset;
    background-color: unset;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }

  nav {
    text-align: left;
    margin: 1rem 1rem;
    font-size: 1.3rem;
    padding: 1rem 0;
  }
}
</style>
